var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "image-panel" },
      [
        _c("app-image", {
          attrs: {
            image: _vm.headerUrl,
            alt: _vm.value.title,
            cropped: _vm.isImgix ? null : _vm.cropped,
            size: _vm.isImgix ? null : _vm.size,
          },
        }),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c("form-text", {
                attrs: {
                  placeholder: "Add a description",
                  "field-size": "is-small",
                  name: _vm.imageName,
                  "has-counter": true,
                  maxlength: 150,
                },
              }),
            ],
            1
          ),
          _vm.isImgix && _vm.feature
            ? _c("div", { staticClass: "column is-2" }, [
                _c(
                  "div",
                  { staticClass: "field focal-point" },
                  [
                    _c("vue-slider", {
                      attrs: { min: 0, max: 1, interval: 0.1 },
                      model: {
                        value: _vm.focalpoint,
                        callback: function ($$v) {
                          _vm.focalpoint = $$v
                        },
                        expression: "focalpoint",
                      },
                    }),
                    _c("small", { staticClass: "help" }, [
                      _vm._v("Focalpoint"),
                    ]),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "image-actions" }, [
          _c(
            "span",
            { staticClass: "has-text-grey", on: { click: _vm.onDelete } },
            [
              _c("dc-icon", {
                attrs: { icon: "trash", "no-margin": "", "left-margin": "" },
              }),
            ],
            1
          ),
        ]),
        _vm.tag
          ? _c("span", {
              staticClass: "tag is-black is-small",
              domProps: { textContent: _vm._s(_vm.tag) },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }